import { morning8am } from '@/util/helpers/time-helpers';

// these must match EnumTriggerType.java
export const S3_BUCKET = 's3_bucket';
export const S3_REGION = 's3_region';

class S3BucketShareRef {
  constructor(
    id,
    credentials,
    viewSeries,
    disabled,
    time,
    scheduledFrequency,
    errorMessage,
  ) {
    this._id = id; // uuid
    this._credentials = credentials; // object with S3_BUCKET, S3_REGION keys.
    this._viewSeries = viewSeries; // uuid
    this._disabled = disabled; // boolean
    this._time = time; // time as ISO timestamp (e.g. 2019-12-17T03:00:00Z)
    this._scheduledFrequency = scheduledFrequency;
    this._errorMessage = errorMessage; // string
  }

  get scheduledFrequency() {
    return this._scheduledFrequency;
  }

  // build from server
  static build(a) {
    return new S3BucketShareRef(
      a.id,
      { [S3_BUCKET]: a.bucket_name, [S3_REGION]: a.region },
      a.view_series,
      a.disabled,
      a.time,
      a.scheduledFrequency,
      a.errorMessage,
    );
  }

  static empty() {
    return new S3BucketShareRef(
      null, // _id
      {}, // _credentials
      '', // _viewSeries:
      true, // _disabled
      morning8am(), // time
      null,
      '', // error message
    );
  }

  id() {
    return this._id;
  }

  credentials() {
    return this._credentials;
  }

  viewSeries() {
    return this._viewSeries;
  }

  disabled() {
    return this._disabled;
  }

  time() {
    return this._time;
  }

  errorMessage() {
    return this._errorMessage;
  }
}

export default S3BucketShareRef;
